import React from 'react';
import styled from 'styled-components';
import { getProfileCredentials } from 'src/utils/auth';
import { Poppins, StyledAvatar } from 'src/common';
import Button from 'src/components/form/Button';
import { useCancelRequestMutation } from 'src/graphql/_generated';
import { showSuccessToast, toastMessages } from 'src/components/Toast';

const Div = styled.div`
  height: 79px;
  background-color: ${({ theme }) => theme.colors.aliceBlue};
  border-radius: 6px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .left {
    position: relative;
    display: grid;
    grid-gap: 15px;
    grid-auto-flow: column;
    align-items: center;
  }

  .requested {
    display: flex;
    align-items: center;
    grid-gap: 40px;
  }
`;

const SButton = styled(Button)`
  height: 36px !important;
  font-size: 14px !important;
  width: 180px;
  padding: 0;
`;

const RejectBtn = styled(SButton)`
  background: ${({ theme }) => theme.colors.white};
  -webkit-background-clip: none;
  -webkit-text-fill-color: ${({ theme }) => theme.colors.gp1};
`;

interface RowRequestProps {
  workspaceId: string;
  name: string;
  organisationName: string;
  img: string | null;
  onSuccess: () => void;
  orgUnitType: string;
}

export const RowRequest: React.FC<RowRequestProps> = ({
  workspaceId,
  name,
  organisationName,
  img,
  onSuccess,
  orgUnitType,
}) => {
  const [cancelRequest, { loading }] = useCancelRequestMutation();

  return (
    <>
      <Div>
        <div className="left">
          <StyledAvatar $small src={img || ''} alt="">
            {getProfileCredentials(name)}
          </StyledAvatar>
          <Poppins px={14} weight={600} color={'prussianBlue'}>
            <Poppins px={14} weight={500} color="cflowerBlue">
              The {orgUnitType === 'O' ? 'organisation' : 'workspace'}{' '}
            </Poppins>
            {name}{' '}
            <i>
              <Poppins px={14} weight={500} color="cflowerBlue">
                in{' '}
                <Poppins px={14} weight={600} color="cflowerBlue">
                  {organisationName}
                </Poppins>
              </Poppins>
            </i>
          </Poppins>
        </div>

        <div className="requested">
          <Poppins px={14} weight={500}>
            Access requested
          </Poppins>
          <RejectBtn
            secondary
            onClick={async () => {
              await cancelRequest({ variables: { workspaceId } });
              await onSuccess();
              showSuccessToast(toastMessages.user.inviteCancelled);
            }}
            disabled={loading}
            loading={loading}
            css="width: 180px"
          >
            CANCEL REQUEST
          </RejectBtn>
        </div>
      </Div>
    </>
  );
};
